import React from "react";
import "./ProgressBarContainer.scss";
import styles from "./ProgressBarContainer.module.scss";
import Kpis from '../../../partials/Kpis'

export const ProgressBarContainer = (props) => {

  return (
    <div
      className={`${styles.Footer_Style}  ${styles.active}`}
    >
      <div className = "KpisFooter" style={{ position: `relative` }}>
        <Kpis kpis={props.meters} markers={props.markers} style={{padding : "0px"}} />
      </div>
    </div>
  );
};

export default ProgressBarContainer;
